import axios from "axios";
//import authGet from './auth-get';

const WELLSUITE = '../../WsWebServiceWellSuite/';
const PLATFORM = '../../WsWebServicePlatform/';
const HRA = '../../WsWebServiceHra/';
const VI = 'GetViewInstance/';

//GET landing page view instance
const getLanding = (groupGuid, languageID) => {
    return axios
        .get(WELLSUITE + 'GetViewInstancePublic/' + groupGuid + '/'+ languageID + '/4F60657A-324B-415C-986A-4ADFD91EBEC2/')
        .then((response) => {
            if(response.data.Success){
                return response.data
            }
        })
}

//GET logout page view instance
const getLogout = (groupGuid, languageID) => {
    return axios
        .get(WELLSUITE + 'GetViewInstancePublic/' + groupGuid + '/'+ languageID + '/9B17E3E1-CDD9-4D91-BC4A-B096B4F99CDE/')
        .then((response) => {
            if(response.data.Success){
                return response.data
            }
        })
}

//GET Passwordd Request VI
const getPWRequest = (groupGuid, languageID) => {
    return axios
        .get(WELLSUITE + 'GetViewInstancePwrRequest/' + groupGuid + '/'+ languageID +'/')
        .then((response) => {
            if(response.data.Success){
                return response.data
            }
        })
}

//GET password reset VI
const getPWReset = (pwrg) => {
    return axios
        .get(WELLSUITE + 'GetViewInstancePwr/' + pwrg+'/')
        .then((response) => {
            if(response.data.Success){
                return response.data
            }
        })
}
 
const getPWResetAuth = (auth) => {
    return axios
        .get(WELLSUITE + 'GetViewInstancePwrAuth/' + auth +'/')
        .then((response) => {
            if(response.data.Success){
                return response.data
            }
        })
}

//Generic View Instance call for VIs that require an auth token
const getViewInstance = (viewInstance, authToken) => {
    return axios
        .get(WELLSUITE + 'GetViewInstance/' + authToken + '/'+ viewInstance +'/')
        .then((response) => {
            if(response.data.Success){
                return response.data
            }
        })
}


export default {
    getLanding,
    getLogout,
    getViewInstance,
    getPWRequest,
    getPWReset,
    getPWResetAuth
}